/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTag {
    getFixupPrototypeFunction() { return TagBaselineAvailableTag.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTag>): TagBaselineAvailableTag {
        let obj = Object.assign(new TagBaselineAvailableTag(), model);
        TagBaselineAvailableTag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTag>): TagBaselineAvailableTag {
        if (!model) return null;
        return TagBaselineAvailableTag.newInstance(<TagBaselineAvailableTag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTag) {
        if (!obj) return;

        models.TagBaselineAvailableTag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTag): boolean {
        Object.setPrototypeOf(obj, TagBaselineAvailableTag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag key
     */
    key: string;

    /**
     * Values for the tag key
     */
    values: Array<string>;

}
